import React, { useState } from "react";
import PropType from "prop-types";
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import { DrawingManager } from "@react-google-maps/api";
import { useFormContext } from "react-hook-form";

const LIBRARIES = ["drawing", "places"];
const GOOGLE_MAP_API_KEY = "AIzaSyBJ7-WmV3fyhS64yd2XTzZQebwtUCrf2nk";


const mapStyles = {
  width: '100%',
  height: '100%'
}

const center = {lat: 7.9527706 , lng: -1.0307118}

const Map = () => {
  const [marker, setMarker] = useState(null);

  const { setValue, getValues } = useFormContext()

  const handleOnMarkerCompleted = (newMarker) => {
    const { position } = newMarker;
    const lat = position.lat();
    const lng = position.lng();
    // console.log(`lat: ${lat}; lng: ${lng}`);
    if (marker) {
      marker.setMap(null);
    }
    setMarker(newMarker);
    setValue('lat', lat)
    setValue('lng', lng)
    setValue('location', `${getValues('lat')} ${getValues('lng')}`)
  };

  return (
    <LoadScript libraries={LIBRARIES} googleMapsApiKey={GOOGLE_MAP_API_KEY}>
      <GoogleMap mapContainerStyle={mapStyles} center={center} zoom={10}>
        <DrawingManager
          drawingMode="marker"
          options={{
            drawingControl: true,
            drawingControlOptions: { drawingModes: ["marker"] }
          }}
          onMarkerComplete={handleOnMarkerCompleted}
        />
      </GoogleMap>
    </LoadScript>
  );
};

Map.propTypes = {
  zoom: PropType.number
};

Map.defaultProps = {
  zoom: 19
};

export default Map;
